/**
 * @generated SignedSource<<e6aabb8a4b3a82911940e62ac86e2813>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LockNoteInput = {
  clientMutationId?: string | null;
  noteId: string;
};
export type LockNoteLockingMutation$variables = {
  input: LockNoteInput;
};
export type LockNoteLockingMutation$data = {
  readonly lockNote: {
    readonly note: {
      readonly canUnlockNote: boolean;
      readonly id: string;
      readonly isLocked: boolean;
    } | null;
  } | null;
};
export type LockNoteLockingMutation = {
  response: LockNoteLockingMutation$data;
  variables: LockNoteLockingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LockNotePayload",
    "kind": "LinkedField",
    "name": "lockNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUnlockNote",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LockNoteLockingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LockNoteLockingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ecca74b47bd52ce2771901b7197107f",
    "id": null,
    "metadata": {},
    "name": "LockNoteLockingMutation",
    "operationKind": "mutation",
    "text": "mutation LockNoteLockingMutation(\n  $input: LockNoteInput!\n) {\n  lockNote(input: $input) {\n    note {\n      id\n      isLocked\n      canUnlockNote\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9dc4e054d0e3f3adce2b9543f68c5bdd";

export default node;
